<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center">
      <b-col lg="8">
        <b-card>
            <div slot="header">Inventory Receipt - dari Media/Display Dilepas 
                <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="save()">
                    <i class="fa fa-save"></i> Save
                </button>
                <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Cancel</b-button>
                </div>
            </div>
            <b-row h-align="center">
                <b-col md="12">
                    <b-row>
                        <b-col lg="7">
                            <b-input-group>
                                <b-input-group-prepend><label>Receiving Date</label></b-input-group-prepend>
                                <b-form-input v-model="frmdata.recivDate" type="date" :state="!$v.frmdata.recivDate.$error"></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="6">
                            <b-input-group>
                                <b-input-group-prepend><label>Status Barang</label></b-input-group-prepend>
                                <b-form-checkbox  class="mt-2" v-model="frmdata.barangbekas" value=1 unchecked-value=0 disabled>Used Items(Barang Bekas)</b-form-checkbox>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">
                                <b-form-radio-group class="mt-2" v-model="frmdata.barangrusak" name="radioRusak">
                                <b-form-radio value="0">Masih bisa dipakai</b-form-radio>
                                <b-form-radio value="1">Rusak</b-form-radio>
                                </b-form-radio-group>
                        </b-col>
                    </b-row>
                    <b-input-group>
                        <b-input-group-prepend><label>Inventory Group</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.inven_catid" :plain="true" :options="headCategories" :state="!$v.frmdata.inven_catid.$error"></b-form-select>
                    </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label>Asset Media dilepas</label></b-input-group-prepend>
                            <b-form-input v-model="frmdata.fixAsetId" readonly></b-form-input>  
                            <b-input-group-append>
                            <b-btn text="Button" @click="lkuFixedAssetShow=true" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                        </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Asset Media Name</label></b-input-group-prepend>
                        <b-form-input v-model="frmdata.description" :state="!$v.frmdata.description.$error"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Asset Location</label></b-input-group-prepend>
                        <b-form-input v-model="frmdata.aslocat" readonly></b-form-input>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Model/Type/Series</label></b-input-group-prepend>
                        <b-form-input readonly v-model="frmdata.typeseries"></b-form-input>
                        <b-input-group-prepend><label style="width:80px;" class="text-right">S/N</label></b-input-group-prepend>
                        <b-form-input readonly v-model="frmdata.serialnumber"></b-form-input>
                    </b-input-group>
                    <!-- <b-row>
                    <b-col lg="12">                             -->
                        <b-input-group>
                            <b-input-group-prepend><label>Inventory ItemCode</label></b-input-group-prepend>
                            <b-form-input readonly v-model="frmdata.partnumber" :state="!$v.frmdata.itemno.$error"></b-form-input>
                            <b-form-input readonly v-model="frmdata.itemname" :state="!$v.frmdata.itemno.$error" style="width:30% !important"></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="lkuItemShow=true" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                        </b-input-group>
                    <!-- </b-col>
                    </b-row >                       -->
                    <!-- <b-input-group>
                        <b-input-group-prepend><label>Inventory ItemName</label></b-input-group-prepend>
                        <b-form-input readonly v-model="frmdata.itemname"></b-form-input>
                    </b-input-group> -->


                <!-- <b-row>
                    <b-col lg="6"> 
                    <b-input-group>
                        <b-input-group-prepend><label>Qty Inventory IN</label></b-input-group-prepend>
                        <b-form-input v-model="frmdata.quantity" type="number" :state="!$v.frmdata.quantity.$error" :min="1"></b-form-input>
                        <b-form-input v-model="frmdata.invunitom" :state="!$v.frmdata.invunitom.$error" class="ml-1"></b-form-input>
                    </b-input-group>
                    </b-col>                  
                    <b-col lg="6">                            
                        <b-input-group>
                            <b-input-group-prepend><label>Inventory Unit price</label></b-input-group-prepend>
                            <b-input-group-prepend>
                            <span class="input-group-text" >{{uanguser}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="frmdata.invUnitCost" :precision="2" ></my-number>
                        </b-input-group>
                    </b-col>
                </b-row >                       -->
                <b-row>
                    <b-col lg="7">                            
                        <b-input-group>
                            <b-input-group-prepend><label>Store/Warehouse </label></b-input-group-prepend>
                            <b-form-select v-model="frmdata.idStore" :plain="true" :options="warehouse" :state="!$v.frmdata.idStore.$error"></b-form-select>
                        </b-input-group>
                    </b-col>
                    <b-col lg="5">                            
                        <b-input-group>
                            <b-input-group-prepend><label style="width:113px !important; text-align:right;">Rack/Shelf No.</label></b-input-group-prepend>
                            <b-form-input v-model="frmdata.shelfNo" :state="!$v.frmdata.shelfNo.$error"></b-form-input>
                        </b-input-group>
                    </b-col>
                </b-row >     
                <!-- <b-row>
                    <b-col lg="7">                            
                        <b-input-group v-if="frmdata.isexpireable">
                            <b-input-group-prepend><label>Expired Date</label></b-input-group-prepend>
                            <b-form-input v-model="frmdata.expirDate" type="date" :state="!$v.frmdata.expirDate.$error"></b-form-input>
                        </b-input-group>
                        <b-input-group v-if="frmdata.ishasserialno">
                            <b-input-group-prepend><label>Serial Number</label></b-input-group-prepend>
                            <b-form-input v-model="frmdata.serialNum" :state="!$v.frmdata.serialNum.$error"></b-form-input>
                        </b-input-group>
                    </b-col>
                </b-row >      -->
                </b-col>
                <!-- <b-col lg="5">
                <v-dim :model="frmdata" ></v-dim>
            </b-col> -->
            </b-row>
            <b-row class="justify-content-center mb-2">
                <button class="btn btn-primary mr-1" @click="save()">
                    <i class="fa fa-save"></i> Save
                </button>
                <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Cancel</b-button>
            </b-row>
            
        </b-card>
      </b-col>
    </b-row>  
    <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Master Item Inventory" :centered="true">
            <lku-item @click="onSelectLkuItem"  jasa="0" isactive="1" :formdata="itemList" ></lku-item>
    </b-modal>        
        <b-modal v-model="lkuFixedAssetShow" size="lg" :hide-footer="true" title="List of Fixed Asset" :centered="true">
            <lku-fixedasset @click="onSelectLkuFixedAsset" :formdata="lkuFixedAssetData"></lku-fixedasset>
        </b-modal>        

  </div>
</template>


<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import lkuItem from "../lookup/lkuItemLazzy";
import lkuFixedasset from "../lookup/lkuFassetLazzy";
import vDim from "../lookup/dim";
import inv from "../../apis/logistic_inv_in";
import item from "../../apis/item";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: { myNumber,lkuItem,lkuFixedasset,vDim},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        recivDate: {required},
        quantity: { required },
        invunitom: { required },
        itemno: { required },
        inven_catid: { required },
        description: { required },
        idStore : { required },
        shelfNo : { required },
        serialNum: { required:requiredIf('isexpireable') },
    },
  },
  data() {
    return {
      lkuFixedAssetShow:false,
      lkuFixedAssetData:{},
      showList:true,
      showForm:false,
      showGCIF:false,
      lkuItemShow:false,
      itemList:{},
      frmdata:{quantity: 1, invunitom: 'PCS',qtykonversi:1, gcif:0, invUnitCost:0, barangbekas:1, barangrusak:0 },
      uanguser: this.$store.state.user.matauang,
      warehouse:[],headCategories:[]
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    isexpireable(){
        return this.frmdata.isexpireable;
    },
    ishasserialno(){
        return this.frmdata.ishasserialno;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },
  created: async function(){
        const [a,b] = await Promise.all([inv.inventorygroup(),inv.store()]) ;
        this.headCategories = a; 
      this.warehouse = b;    
  },
  methods: {
    onSelectLkuFixedAsset: async function(lkuData) {
        this.lkuFixedAssetData=lkuData;
        this.lkuFixedAssetShow=false;

        this.frmdata.fixAsetKey = lkuData.selected.asetkey;
        this.frmdata.fixAsetId = lkuData.selected.asetid;
        this.frmdata.asdesc = lkuData.selected.asdesc;
        this.frmdata.description = lkuData.selected.asdesc;
        this.frmdata.serialnumber = lkuData.selected.asserial;
        this.frmdata.typeseries = lkuData.selected.asmodel;
        this.frmdata.aslocat = lkuData.selected.aslocat;
            this.dimension.forEach((dim) => {
                if (lkuData.selected[dim.value] && !this.frmdata[dim.value]) {
                    this.frmdata[dim.value] = lkuData.selected[dim.value];
                    this.frmdata[`${dim.value}Txt`] = lkuData.selected[`${dim.value}Txt`];
                    this.frmdata[`${dim.value}Info`] = lkuData.selected[`${dim.value}Info`];
                }
            });

        if (lkuData.selected.itemno) {     
            if (lkuData.selected.itemname) {
                    this.frmdata.iteminfo = lkuData.selected.iteminfo;
                    this.frmdata.itemno = lkuData.selected.itemno;
                    this.frmdata.itemname = lkuData.selected.itemname;
                    this.frmdata.partnumber = lkuData.selected.partnumber;
            }  else {     
                toastr.info('Loading Master Item, please wait')
                try {
                    const data = await item.detail({itemno:lkuData.selected.itemno});  
                    const selectedItem = data[0];
                    if (selectedItem) {
                        this.frmdata.iteminfo = selectedItem.partnumber.trim() + ' | ' + selectedItem.itemname.trim();
                        this.frmdata.itemno = selectedItem.itemno;
                        this.frmdata.itemname = selectedItem.itemname;
                        this.frmdata.isexpireable = selectedItem.isexpireable;
                        this.frmdata.ishasserialno = selectedItem.ishasserialno;
                        this.frmdata.invunitom = selectedItem.invunitom;
                        this.frmdata.unitsize = selectedItem.unitsize;
                        this.frmdata.itemcategory = selectedItem.itemcategory;
                        this.frmdata.partnumber = selectedItem.partnumber;
                        this.frmdata.konsinyasi = selectedItem.konsinyasi;
                        this.frmdata.qtyUndefined = selectedItem.qtyUndefined;
                    }
                } catch (error) {
                    console.log('error : ', error);
                    toastr.error(JSON.stringify(error), "ERROR MESSAGE",10000);                              
                }

            }
            // if (selectedItem.invenDbAcc) {
            //     const ada = this.headCategories.find(c => c.kodeacc==selectedItem.invenDbAcc);
            //     if (ada) {
            //         this.frmdata.inven_catid=selectedItem.invenDbAcc
            //     }
            // }
            this.$forceUpdate();
            toastr.clear;
        }
    },
    onSelectLkuItem:  function (lkuData) {
        this.itemList=lkuData;
        this.lkuItemShow=false;

        this.frmdata.iteminfo = lkuData.selected.partnumber.trim() + ' | ' + lkuData.selected.itemname.trim();
        this.frmdata.itemno = lkuData.selected.itemno;
        this.frmdata.itemname = lkuData.selected.itemname;
        this.frmdata.isexpireable = lkuData.selected.isexpireable;
        this.frmdata.ishasserialno = lkuData.selected.ishasserialno;
        this.frmdata.invunitom = lkuData.selected.invunitom;
        this.frmdata.unitsize = lkuData.selected.unitsize;
        this.frmdata.itemcategory = lkuData.selected.itemcategory;
        this.frmdata.partnumber = lkuData.selected.partnumber;
        this.frmdata.konsinyasi = lkuData.selected.konsinyasi;
        this.frmdata.qtyUndefined = lkuData.selected.qtyUndefined;
        // if (lkuData.selected.invenDbAcc) {
        //     const ada = this.headCategories.find(c => c.kodeacc==lkuData.selected.invenDbAcc);
        //     if (ada) {
        //         this.frmdata.inven_catid=lkuData.selected.invenDbAcc
        //     }
        // }
        this.frmdata.inven_catid=lkuData.selected.inven_catid
    },
    save: async function (callback) {      
        if (this.invalidFormdata) {
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            console.log('validation : ', this.$v.frmdata);
            console.log('frmdata obj : ',this.frmdata);
        } else {
            try {
              // Note apakah perlu dibuatkan validation saat input gcif
              // this.frmdata.gcifData = this.frmGCIFdata;
              // const result = await inv.invReceipt_save(this.frmdata);
              this.frmdata.invValue = this.frmdata.invUnitCost * this.frmdata.quantity;
              this.frmdata.invValueFCY = this.frmdata.invValue;
              this.frmdata.invUnitCostFCY = this.frmdata.invUnitCost;
            //   this.frmdata.purcOrderNo = this.frmdata.purcOrderNo || (this.frmdata.barangbekas==1) ? 'BEKAS' : '' ;
              await inv.saveMediaLepas(this.frmdata);
              this.showGCIF = false;
              this.showForm = false;
              toastr.success("Complete successfully", "Save Inventory Receipt");
              router.push({name :'logistic.inv_in'});
            } catch (error) {
                // this.saveEnabled=true;
                // this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
        }
    },        
    close(){
        router.push({name:'logistic.inv_in'});
    },   
  }
};
</script>
